var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", { staticClass: "dashboard-block" }, [
    _c("h2", [_vm._v("Date and Time Preferences")]),
    _vm._v(" "),
    _c("div", { staticClass: "panel panel-grey" }, [
      _c(
        "div",
        { staticClass: "panel-body" },
        [
          _c("h3", [_vm._v("Timezone")]),
          _vm._v(" "),
          _c("selectize", {
            staticClass: "selectize selectize-single",
            attrs: { name: "timezone", options: _vm.timezoneOptions },
            model: {
              value: _vm.stateTimezone,
              callback: function ($$v) {
                _vm.stateTimezone = $$v
              },
              expression: "stateTimezone",
            },
          }),
          _vm._v(" "),
          _vm.$userIsGlobalAdmin && _vm.regionOptions.length > 1
            ? [
                _c("h3", [_vm._v("Region")]),
                _vm._v(" "),
                _c("selectize", {
                  staticClass: "selectize selectize-single",
                  attrs: { name: "timezone", options: _vm.regionOptions },
                  model: {
                    value: _vm.stateRegion,
                    callback: function ($$v) {
                      _vm.stateRegion = $$v
                    },
                    expression: "stateRegion",
                  },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("h3", [_vm._v("Preferred Date Format")]),
          _vm._v(" "),
          _c("selectize", {
            staticClass: "selectize selectize-single",
            attrs: { name: "timezone", options: _vm.dateFormatOptions },
            model: {
              value: _vm.stateDateFormat,
              callback: function ($$v) {
                _vm.stateDateFormat = $$v
              },
              expression: "stateDateFormat",
            },
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "panel-footer" },
        [
          _c(
            "ladda-button",
            {
              staticClass: "btn btn-sm btn-primary",
              attrs: {
                type: "submit",
                click: _vm.handleUpdateDateTimePreferencesCallback,
                disabled: _vm.userIsAdmin && !_vm.canEditAdmin,
              },
            },
            [_vm._v("\n        Save Changes\n      ")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }